import { chakra } from '@plurall/elo-v3';

import {
  learningPathsToolbarFieldRecipe,
  learningPathsToolbarRootRecipe,
  learningPathsToolbarSearchRecipe,
} from './learning-paths-toolbar.recipe';

export const LearningPathsToolbarRootFactory = chakra('div', learningPathsToolbarRootRecipe);
export const LearningPathsToolbarSearchFactory = chakra('div', learningPathsToolbarSearchRecipe);
export const LearningPathsToolbarFieldFactory = chakra('div', learningPathsToolbarFieldRecipe);
